import { render, staticRenderFns } from "./model.vue?vue&type=template&id=6b4b4ce6&"
import script from "./model.vue?vue&type=script&lang=js&"
export * from "./model.vue?vue&type=script&lang=js&"
import style0 from "./model.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports